import { render } from "./VideosAdmin.vue?vue&type=template&id=3eafb88f&scoped=true"
import script from "./VideosAdmin.vue?vue&type=script&lang=ts"
export * from "./VideosAdmin.vue?vue&type=script&lang=ts"

import "./VideosAdmin.vue?vue&type=style&index=0&id=3eafb88f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3eafb88f"

export default script